import React from 'react';

interface WelcomeProps {
  eventName: string;
  onStart: () => void;
}

export default function Welcome({ eventName, onStart }: WelcomeProps) {
  return (
    <div className="page welcome">
      <div className="welcome__card">
        <h1 className="welcome__title">Thank you</h1>
        <p className="welcome__subtitle">
          Thank you so much for being part of <strong>{eventName}</strong>. Your experience matters to us.
        </p>
        <p className="welcome__intro">
          We’d love to hear your feedback. Every single answer is <strong>optional</strong>. You can skip any question—there’s a <strong>Skip</strong> button at the bottom of each screen. Take your time, and answer only what you’re comfortable with.
        </p>
        <p className="welcome__note">
          You can return anytime to finish, review, or reset your survey. We’ll remember where you left off.
        </p>
        <button type="button" className="btn btn--primary welcome__cta" onClick={onStart}>
          Start survey
        </button>
      </div>
    </div>
  );
}
